import { SxProps, Theme } from '@mui/material';

export const MaintenanceRootStyles: SxProps<Theme> = {
  alignItems: 'center',
  background:
    'radial-gradient(circle at top right, rgba(246, 131, 21, 0.08), transparent 28%), linear-gradient(180deg, #f7f8fa 0%, #eef1f4 100%)',
  display: 'flex',
  justifyContent: 'center',
  minHeight: '100dvh',
  px: {
    sm: 4,
    xs: 2,
  },
};

export const MaintenancePanelStyles: SxProps<Theme> = {
  backgroundColor: 'rgba(255, 255, 255, 0.96)',
  border: theme => `1px solid ${theme.colors.stroke}`,
  borderRadius: '14px',
  borderTop: theme => `4px solid ${theme.colors.orange}`,
  boxShadow: '0 18px 48px rgba(17, 17, 17, 0.08)',
  display: 'flex',
  flexDirection: 'column',
  maxWidth: 720,
  px: {
    sm: 6,
    xs: 3,
  },
  py: {
    sm: 6,
    xs: 4,
  },
  width: '100%',
};

export const MaintenanceLogoStyles: SxProps<Theme> = {
  height: 48,
  mb: {
    sm: 5,
    xs: 4,
  },
  width: 154,
};

export const MaintenanceContentStyles: SxProps<Theme> = {
  alignItems: {
    sm: 'flex-start',
    xs: 'center',
  },
  display: 'flex',
  flexDirection: {
    sm: 'row',
    xs: 'column',
  },
  gap: {
    sm: 4,
    xs: 3,
  },
  width: '100%',
};

export const MaintenanceIconStyles: SxProps<Theme> = {
  '& svg': {
    fontSize: 26,
  },
  alignItems: 'center',
  backgroundColor: theme => theme.colors.yellow76,
  border: theme => `1px solid ${theme.colors.lightOrange}`,
  borderRadius: '8px',
  color: 'warning.main',
  display: 'flex',
  flex: '0 0 auto',
  height: 48,
  justifyContent: 'center',
  width: 48,
};

export const MaintenanceTextStyles: SxProps<Theme> = {
  maxWidth: 520,
  textAlign: {
    sm: 'left',
    xs: 'center',
  },
};

export const MaintenanceTitleStyles: SxProps<Theme> = {
  color: 'primary.black',
  mb: 2,
  typography: {
    sm: 'f32Medium',
    xs: 'f24Medium',
  },
};

export const MaintenanceMessageStyles: SxProps<Theme> = {
  color: 'primary.black_65',
  typography: 'f18Regular',
};
